import React, { useState } from 'react';
import { Box, Card, CardContent, Stack, TextField, Typography } from '@mui/material';
import { BackNavIconVariant } from '_lex/_atoms/NavigationHeader/index';
import { TakeoverLayout } from '_lex/_layouts/TakeoverLayout';
import { translate as t } from 'hooks/useTranslations';
import { neutral } from '_lex/_foundations/phxColors';
import { useDiscardWorkflowLeaveConfirm } from './_components/discardWorkflowLeaveConfirm';
import { editableStepTextFieldSx, readOnlyDashedTextFieldSx } from './workflowStepFieldStyles';

const stepStackSpacing = 1;

const ReviewWorkflowNew: React.FC = () => {
  const handleCloseNavigation = useDiscardWorkflowLeaveConfirm();
  const [supervisorStepName, setSupervisorStepName] = useState(() =>
    t('performanceReporting.reviewWorkflows.new.steps.supervisorReview')
  );

  const pageTitle = t('performanceReporting.reviewWorkflows.new.pageTitle');
  const submittedLabel = t('performanceReporting.reviewWorkflows.new.steps.submitted');
  const supervisorAriaLabel = t('performanceReporting.reviewWorkflows.new.steps.supervisorReview');
  const approvedLabel = t('performanceReporting.reviewWorkflows.new.steps.approved');

  return (
    <TakeoverLayout
      pageTitle={pageTitle}
      backNavIcon={BackNavIconVariant.Close}
      backNavAriaLabel={t('performanceReporting.reviewWorkflows.new.closeAriaLabel')}
      onBackClick={handleCloseNavigation}
      contentBackground='neutral'
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 720,
          mx: 'auto',
        }}
      >
        <Card
          elevation={0}
          sx={{
            border: `1px solid ${neutral[100]}`,
            borderRadius: 2,
            bgcolor: neutral[25],
            boxShadow: 'none',
            overflow: 'hidden',
          }}
        >
          <Box
            component='header'
            sx={{
              bgcolor: neutral[50],
              borderBottom: `1px solid ${neutral[100]}`,
              px: 4,
              py: 4,
            }}
          >
            <Typography
              variant='subtitleLg'
              component='h2'
              sx={{
                fontWeight: 600,
                color: neutral[500],
              }}
            >
              {t('performanceReporting.reviewWorkflows.new.steps.title')}
            </Typography>
          </Box>
          <CardContent
            sx={{
              bgcolor: neutral[25],
              pt: 3,
              px: 8,
              py: 4,
            }}
          >
            <Stack spacing={stepStackSpacing}>
              <TextField
                fullWidth
                variant='outlined'
                value={submittedLabel}
                InputProps={{ readOnly: true }}
                inputProps={{
                  'aria-label': submittedLabel,
                }}
                sx={readOnlyDashedTextFieldSx}
              />

              <TextField
                fullWidth
                variant='outlined'
                value={supervisorStepName}
                onChange={(e) => setSupervisorStepName(e.target.value)}
                inputProps={{
                  'aria-label': supervisorAriaLabel,
                }}
                sx={editableStepTextFieldSx}
              />

              <TextField
                fullWidth
                variant='outlined'
                value={approvedLabel}
                InputProps={{ readOnly: true }}
                inputProps={{
                  'aria-label': approvedLabel,
                }}
                sx={readOnlyDashedTextFieldSx}
              />
            </Stack>
          </CardContent>
        </Card>
      </Box>
    </TakeoverLayout>
  );
};

export default ReviewWorkflowNew;
